// src/components/DashboardShimmer.tsx

import "./index.css"

const DashboardShimmer = () => {
  return (
    <main className="flex-1 overflow-y-auto p-3 md:px-8 scroll-smooth">
      <div className="mx-auto max-w-7xl flex flex-col gap-6">

        {/* Filter Panel Skeleton */}
        <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-sm border border-slate-200 dark:border-slate-800 overflow-hidden">
          <div className="px-6 py-4 border-b border-slate-200 dark:border-slate-800 flex items-center justify-between">
            <div className="h-7 w-32 rounded bg-slate-200 dark:bg-slate-700" />
            <div className="flex gap-3">
              <div className="h-10 w-10 rounded-full bg-slate-200 dark:bg-slate-700" />
              <div className="h-10 w-10 rounded-full bg-slate-200 dark:bg-slate-700" />
            </div>
          </div>
          <div className="p-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
              {Array.from({ length: 4 }).map((_, i) => (
                <div key={i} className="space-y-2">
                  <div className="h-5 w-20 rounded bg-slate-200 dark:bg-slate-700" />
                  <div className="h-11 w-full rounded-xl bg-slate-200 dark:bg-slate-700" />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Stats Cards - Row 1 (4 cards) */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {Array.from({ length: 4 }).map((_, i) => (
            <div
              key={`stat1-${i}`}
              className="flex flex-col gap-3 rounded-xl p-6 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-sm relative overflow-hidden"
            >
              <div className="absolute right-0 top-0 p-4 opacity-20">
                <div className="h-16 w-16 rounded-full bg-slate-200 dark:bg-slate-700" />
              </div>
              <div className="h-5 w-32 rounded bg-slate-200 dark:bg-slate-700" />
              <div className="h-10 w-24 rounded bg-slate-200 dark:bg-slate-700" />
            </div>
          ))}
        </div>

        {/* Stats Cards - Row 2 (3 cards) */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {Array.from({ length: 3 }).map((_, i) => (
            <div
              key={`stat2-${i}`}
              className="flex flex-col gap-3 rounded-xl p-6 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-sm relative overflow-hidden"
            >
              <div className="absolute right-0 top-0 p-4 opacity-20">
                <div className="h-16 w-16 rounded-full bg-slate-200 dark:bg-slate-700" />
              </div>
              <div className="h-5 w-40 rounded bg-slate-200 dark:bg-slate-700" />
              <div className="h-10 w-24 rounded bg-slate-200 dark:bg-slate-700" />
            </div>
          ))}
        </div>

        {/* Map + Recent Violations Skeleton */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 h-[600px] min-h-[500px]">
          {/* Map Placeholder */}
          <div className="lg:col-span-2 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 shadow-sm overflow-hidden">
            <div className="h-full w-full">
              <Shimmer />
            </div>
          </div>

          {/* Recent Violations Skeleton */}
          <div className="flex flex-col rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 shadow-sm overflow-hidden h-full">
            <div className="p-4 border-b border-slate-200 dark:border-slate-700">
              <div className="flex items-center gap-2">
                <div className="h-6 w-6 rounded bg-slate-200 dark:bg-slate-700" />
                <div className="h-6 w-36 rounded bg-slate-200 dark:bg-slate-700" />
              </div>
            </div>
            <div className="flex-1 p-4 space-y-4">
              {Array.from({ length: 4 }).map((_, i) => (
                <div key={i} className="space-y-3">
                  <div className="flex justify-between">
                    <div className="h-5 w-3/5 rounded bg-slate-200 dark:bg-slate-700" />
                    {/* <div className="h-5 w-16 rounded bg-slate-200 dark:bg-slate-700" /> */}
                  </div>
                  <div className="h-4 w-2/5 rounded bg-slate-200 dark:bg-slate-700" />
                  <div className="h-4 w-full rounded bg-slate-200 dark:bg-slate-700" />
                  <div className="h-4 w-4/5 rounded bg-slate-200 dark:bg-slate-700" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default DashboardShimmer;

// src/components/Shimmer.tsx
const Shimmer = () => {
  return (
    <div className="animate-pulse bg-gradient-to-r from-slate-100 via-slate-200 to-slate-100 dark:from-slate-800 dark:via-slate-700 dark:to-slate-800 bg-[length:200%_100%] bg-left" />
  );
};

